import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import { TableContentForCheckrollWeighReport } from '../../../Common/Table/tableContent';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPdf from "react-to-pdf";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import { TotalCheckRollSummaryReportCategoryObject } from '../TotalCheckRollSummaryReportCategorySchema';
import { validateProperty, validate } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { keys } from 'lodash';
import '../Pages/tableFooter.css';
import xlsx from 'json-as-xlsx';

const screenCode = 'TOTALCHECKROLLWEIGHMENTSUMMARYREPORT';

export function TotalCheckRollSummaryReportListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState();
    const [fields, setFields] = useState();
    const [errors, setErrors] = useState({});
    const [sessions, setSessions] = useState({});
    const [finalData, setFinalData] = useState({});
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1070, 700]
    };

    const schema = Joi.object(TotalCheckRollSummaryReportCategoryObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [collectionCategoryReport, setcollectionCategoryReport] = useState([])
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);

    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            searchDate: ""
        }
    );

    const [contentRowNames, setContentRowNames] = useState(["epfNo", "registrationNumber",
        "firstName", "collectionPointName", "fieldName", "gangName", "actualAmount", "totalDeduction", "grossAmount",
        "netAmount", "extraKg", "profit"])
    const [isTableHide, setIsTableHide] = useState(true);
    const [excelData, setExcelData] = useState([]);
    const [deductionTypeNamesOfTable, setDeductionTypeNamesOfTable] = useState([]);
    const [feildAvailabeDedauctionTypes, setFeildAvailabeDedauctionTypes] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        feild: "",
        session: "",
        date: ""
    })
    const initialContentRowNames = ["epfNo", "registrationNumber", "firstName",
        "collectionPointName", "fieldName", "actualAmount", "grossAmount", "netAmount", "extraKg", "profit"];
    const initialCsvHeaders = [
        { label: "EPF No", value: "epfNo" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "First Name", value: "firstName" },
        { label: "Division", value: "collectionPointName" },
        { label: "Field", value: "fieldName" },
        { label: "Actual (Kg)", value: "actualAmount" },
        { label: "Net (Kg)", value: "grossAmount" },
        { label: "Checkroll (Kg)", value: "netAmount" },
        { label: "Extra (Kg)", value: "extraKg" },
        { label: "Gain/ Loss (Kg)", value: "profit" }
    ];
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [detailCard, setDetailCard] = useState({
        gross: 0,
        net: 0,
        total: 0,
        gainloss: 0,
        extraKg: 0,
        allTot: 0
    });
    const [detailDeductions, setDetailDeductions] = useState([]);
    const [employeeCount, setEmployeeCount] = useState(0);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown(),
            getDeductionTypesForTable()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            GetDivisionForDropDown(),
            getMobileSessions()
        )
    }, [searchForm.estateID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.divisionID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.searchDate]);

    useEffect(() => {
        trackPromise(
            getMobileSessions()
        )
    }, [searchForm.fieldID]);

    async function getMobileSessions() {
        if (searchForm.searchDate !== "")
            getMobileSessionsForDropDown();
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTOTALCHECKROLLWEIGHMENTSUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function getDeductionTypesForTable() {
        const deductionTypeNames = await services.GetAllDedtuctionTypeNames();
        setDeductionTypeNamesOfTable(deductionTypeNames);
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(searchForm.estateID);
        setDivisions(routeList);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetAvialableFieldsForDropdown(searchForm);
        setFields(fields);
    }

    async function getMobileSessionsForDropDown() {
        const selectedSessions = await services.GetMobileSessionsForWeighReport(searchForm);
        setSessions(selectedSessions);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, TotalCheckRollSummaryReportCategoryObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            divisionID: target.value,
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: "0",
            sessionID: "0",
            searchDate: target.value
        });
    }

    function handleFieldChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: target.value,
            sessionID: "0"
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, TotalCheckRollSummaryReportCategoryObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        e.preventDefault();

        setIsTableHide(true);

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchForm);
        var reportData = await services.GetWeighReportData(searchForm);

        var weighReport = reportData.weighReportsData;
        var deductionTypes = reportData.availableDeduction;

        deductionTypes.forEach((val, index) => deductionTypes[index] = val.deductionTypeName);

        setFeildAvailabeDedauctionTypes(deductionTypes);

        let arrayCollection = [];
        arrayCollection = mergeDataByBag(weighReport, deductionTypes);
        var finalResult = _.uniqBy(arrayCollection, "employeeID")
        console.log("finalResult",finalResult);
        console.log("reportData",reportData);
        let totalArray = [];

        finalResult.forEach((x, i) => {
            var filteredArray = _.filter(arrayCollection, { 'employeeID': x.employeeID });

            var checkRollTotal = _.sumBy(filteredArray, 'netAmount');
            var extraKgTotal = _.sumBy(filteredArray, 'extraKg');
            var allTotal = checkRollTotal + extraKgTotal;
            totalArray.push({
                "total": allTotal,
                "dataArray": filteredArray,
                "employeeID": x.employeeID,
                "epfNo": x.epfNo,
                "firstName": x.firstName,
                "registrationNumber": x.registrationNumber,
                "collectionPointName": x.collectionPointName
            })
        });

        setFinalData(totalArray);

        let rowNames = initialContentRowNames;
        let headerNames = initialCsvHeaders;

        rowNames.splice(6, 0, ...deductionTypes);

        deductionTypes.forEach((x, i) => {
            headerNames.splice((6 + i), 0, { label: x, value: x },);
        })

        setContentRowNames(rowNames);
        setCsvHeaders(headerNames);

        if (arrayCollection.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
            setcollectionCategoryReport(arrayCollection);
            generateSummaryCard(arrayCollection, deductionTypes);
            createDataTable(rowNames, ['#summaryReport', '#summaryReportPdf']);
            setDataForExcelData(arrayCollection)
        } else {
            setIsReportButtonsEnabled(false);
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Total Checkroll Summary Report',
            fileName: 'TotalCheckrollWeighmentSummaryReport',
            writeOptions: {}
        }

        var copyOfReportData = _.cloneDeep(collectionCategoryReport);
        var newRecord = {};
        var recordArray = [];

        recordArray.push(
            { name: "epfNo", value: "Total:   Employee Count " + employeeCount },
            { name: "actualAmount", value: detailCard.total },
            { name: "grossAmount", value: detailCard.gross },
            { name: "netAmount", value: detailCard.net },
            { name: "extraKg", value: detailCard.extraKg },
            { name: "profit", value: detailCard.gainloss < 0 ? "Loss " + detailCard.gainloss : "Gain " + detailCard.gainloss },
        )

        var selectedDetails = {
            empCount: "Group: " + selectedSearchValues.group,
            epfNo: "Estate: " + selectedSearchValues.estate,
            registrationNumber: "Division: " + (selectedSearchValues.division === undefined ? "All Divisions" : selectedSearchValues.division),
            firstName: "Feild: " + (selectedSearchValues.feild === undefined ? "All Feilds" : selectedSearchValues.feild),
            collectionPointName: "Date: " + selectedSearchValues.date
        }

        recordArray.push(...detailDeductions);

        recordArray.forEach(x => {
            if (x.name === "profit" || x.name === "epfNo") {
                newRecord[x.name] = x.value
            } else {
                newRecord[x.name] = parseFloat(x.value)
            }
        });

        copyOfReportData.sort((a, b) => a.registrationNumber.localeCompare(b.registrationNumber));

        copyOfReportData.push(newRecord, {}, {}, selectedDetails);

        xlsx(csvHeaders, copyOfReportData, settings, true);
    }

    function mergeDataByBag(data, deductionTypes) {

        var result = [];
        var extraKgRecords = [];

        let groupedResult = groupByDetailsID(data);

        let keys = Object.keys(groupedResult);
        let arrayCollection = [];

        keys.forEach(x => {
            var res = mergeDataByDetailsID(groupedResult[x]);
            if (res.length !== 0)
                arrayCollection.push(res);
        });

        arrayCollection.forEach(d => {

            var selectedRecord = result.filter(e =>
                e.pluckingCollectionID === d.pluckingCollectionID);

            if (selectedRecord.length === 0) {
                if (d.extraKg === 0) {
                    result.push(d);
                }
                else {
                    var exsitingExtraKg = extraKgRecords.filter(x => x.employeeID === d.employeeID);

                    if (exsitingExtraKg.length === 0) {
                        extraKgRecords.push({ id: d.employeeID, extraKgTot: d.extraKg });
                    } else {
                        exsitingExtraKg[0].extraKgTot = exsitingExtraKg[0].extraKgTot + d.extraKg;
                    }
                }
            }
            else {
                if (d.extraKg === 0) {
                    deductionTypes.forEach(a => {
                        if (selectedRecord[0][a] !== undefined) {
                            var tot = selectedRecord[0][a] + (d[a] === undefined ? 0 : d[a]);
                            selectedRecord[0][a] = roundNumbers(tot);
                        } else {
                            selectedRecord[0][a] = roundNumbers(d[a])
                        }
                    })

                    selectedRecord[0].netAmount = d.netAmount;
                    selectedRecord[0].grossAmount = selectedRecord[0].grossAmount + d.grossAmount;
                    selectedRecord[0].actualAmount = selectedRecord[0].actualAmount + d.actualAmount;
                }
            }
        });

        result.forEach(x => {
            x.netAmount = x.netAmount.toFixed(2);
            x.grossAmount = x.grossAmount.toFixed(2);

            var diffrence = (x.actualAmount - x.netAmount).toFixed(2);

            x.profit = diffrence < 0 ? "Loss " + Math.abs(diffrence) : "Gain " + Math.abs(diffrence);
            x.gainLoss = diffrence;
        });

        var res = mergeDataByEmployee(result, deductionTypes, extraKgRecords);
        return res;
    }

    function mergeDataByDetailsID(data) {
        var result;

        data.forEach(d => {
            if (result === undefined) {
                var newRecord = addNewEmployee(d);
                result = newRecord;
            }
            else {
                if (result[d.deductionTypeName] !== undefined) {
                    var tot = result[d.deductionTypeName] + d.deductionAmount;
                    result[d.deductionTypeName] = roundNumbers(tot);
                } else {
                    result[d.deductionTypeName] = roundNumbers(d.deductionAmount)
                }
            }
        });

        return result;
    }

    function groupByDetailsID(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['pluckingCollectionDetailsID']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function mergeDataByEmployee(employees, deductionTypes, extraKg) {
        var result = [];

        var empCopy = [...employees];

        let empCount = new Set(empCopy.map(x => x.employeeID)).size;
        setEmployeeCount(empCount);

        empCopy.forEach(d => {
            var selectedRecord = result.filter(e => e.employeeID === d.employeeID
                && e.fieldID === d.fieldID && e.registrationNumber === d.registrationNumber);
            if (selectedRecord.length === 0) {
                result.push(d);
            }
            else {
                deductionTypes.forEach(dt => {
                    if (selectedRecord[0][dt] !== undefined) {
                        selectedRecord[0][dt] = roundNumbers(selectedRecord[0][dt] + d[dt]);
                    }
                });

                selectedRecord[0].netAmount = parseFloat(selectedRecord[0].netAmount) + parseFloat(d.netAmount);
                selectedRecord[0].grossAmount = parseFloat(selectedRecord[0].grossAmount) + parseFloat(d.grossAmount);
                selectedRecord[0].actualAmount = parseFloat(selectedRecord[0].actualAmount) + parseFloat(d.actualAmount);
            }
        });

        empCopy.forEach(x => {
            var extraKgRecord = extraKg.filter(e => e.id === x.employeeID);

            x.extraKg = extraKgRecord.length > 0 ? extraKgRecord[0].extraKgTot : 0;

            x.actualAmount = roundNumbers(parseFloat(x.actualAmount));
            x.netAmount = roundNumbers(parseFloat(x.netAmount));
            x.grossAmount = roundNumbers(parseFloat(x.grossAmount));

            var diffrence = parseFloat(x.grossAmount - x.netAmount).toFixed(2);

            x.profit = diffrence < 0 ? "Loss " + Math.abs(diffrence) : "Gain " + Math.abs(diffrence);
            x.gainLoss = diffrence;
        })

        return result;
    }

    function addNewEmployee(data) {
        var employee = {
            collectionPointID: data.collectionPointID,
            employeeID: data.employeeID,
            epfNo: data.epfNo,
            fieldName: data.fieldName,
            firstName: data.firstName,
            collectionPointName: data.collectionPointName,
            fieldID: data.fieldID,
            mobileSubSessionID: data.mobileSubSessionID,
            actualAmount: data.actualAmount,
            registrationNumber: data.registrationNumber,
            convertedEmployeeBiometricData: data.convertedEmployeeBiometricData,
            gangName: data.gangName,
            netAmount: data.netAmount,
            pluckingCollectionID: data.pluckingCollectionID,
            grossAmount: data.grossAmount,
            extraKg: data.extraKg
        };

        if (data.deductionTypeName !== null) {
            employee[data.deductionTypeName] = roundNumbers(data.deductionAmount);
        }

        return employee;
    }

    function generateSummaryCard(array, dedTypes) {
        var gross = 0;
        var net = 0;
        var total = 0;
        var gainLoss = 0;
        var extraKg = 0;
        var allTot = 0;
        var deductionTypeTot = [];

        array.forEach(val => {

            gross = gross + parseFloat(val.grossAmount);
            net = net + parseFloat(val.netAmount);
            total = total + parseFloat(val.actualAmount);
            gainLoss = gainLoss + parseFloat(val.gainLoss);
            extraKg = extraKg + parseFloat(val.extraKg);
            allTot = extraKg + net;

            dedTypes.forEach(x => {
                var isExsist = deductionTypeTot.find(v => v.name === x);

                if (isExsist) {
                    if (val[x] !== undefined) {
                        isExsist.value = isExsist.value + val[x];
                    }
                } else {
                    if (val[x] !== undefined) {
                        var obj = { name: x, value: val[x] };
                        deductionTypeTot.push(obj)
                    }
                }
            });
        });

        setDetailDeductions(deductionTypeTot);
        setDetailCard({
            ...detailCard,
            gross: gross.toFixed(2),
            net: net,
            total: total.toFixed(2),
            gainloss: gainLoss.toFixed(2),
            extraKg: extraKg,
            allTot: allTot
        })
    }

    function setDataForExcelData(data) {
        var res = [];
        var dataCopy = _.cloneDeep(data);

        dataCopy.forEach(x => {

            var a = _.cloneDeep(x);

            delete a[0].collectionPointID;
            delete a[0].fieldID;
            delete a[0].mobileSubSessionID;
            delete a[0].convertedEmployeeBiometricData;
            delete a[0].pluckingCollectionID;

            res.push(a);

        });
        setExcelData(res);
    }

    function roundNumbers(number) {
        return Math.round((number + Number.EPSILON) * 100) / 100
    }

    function createDataTable(rowNames, dataTables) {
        dataTables.forEach(x => {
            var t = $(x).DataTable({
                retrieve: true,
                destroy: x === '#summaryReportPdf' ? true : false,
                searching: x === '#summaryReportPdf' ? false : true,
                paging: x === '#summaryReportPdf' ? false : true,
                ordering: true,
                order: [[1, "asc"]]
            });
        })
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            feild: fields[searchForm.fieldID],
            date: searchForm.searchDate
        })
    }

    function totalRowCreate(array) {

        var rows = [];
        for (var i = 1; i < array.length; i++) {
            rows.push(<tr>
                <td>{array[i].fieldName}</td>
                <td style={{ textAlign: "right" }}>{array[i].actualAmount}</td>
                <td style={{ textAlign: "right" }}>{array[i].grossAmount}</td>
                <td style={{ textAlign: "right" }}>{array[i].netAmount}</td>
                <td style={{ textAlign: "right" }}>{array[i].extraKg}</td>
                <td style={{ textAlign: "right" }}>
                    <span className={array[i].gainLoss < 0 ? "badge badge-danger" : "badge badge-primary"}>
                        {array[i].gainLoss < 0 ? "Loss " : "Gain "}
                        {Math.abs(array[i].gainLoss)}
                    </span>
                </td>
            </tr>);
        }
        return rows;

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div ref={pdfRef} className="card">
                        <PageHeader
                            title="Total Check Roll Weighment Summary Report"
                        />
                        <div className="card-body">

                            <div className="row">
                                <div className="col">
                                    <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="groupID">Group *</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="groupID"
                                                    disabled={!permissionList.isGroupFilterEnabled}
                                                    name="groupID"
                                                    value={searchForm.groupID}
                                                    onChange={(e) => handleGroupChange(e.target)}>
                                                    <MenuItem value="0">--Select Group--</MenuItem>
                                                    {generateDropDownMenu(groups)}
                                                </Select>
                                                {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="estateID">Estate</InputLabel>
                                                <Select fullWidth
                                                    id="estateID"
                                                    name="estateID"
                                                    disabled={!permissionList.isOperationEntityFilterEnabled}
                                                    value={searchForm.estateID}
                                                    onChange={(e) => handleEstateChange(e.target)}>
                                                    <MenuItem value="0">--Select Estate--</MenuItem>
                                                    {generateDropDownMenu(estates)}
                                                </Select>
                                                {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="divisionID">Division *</InputLabel>
                                                <Select fullWidth
                                                    id="divisionID"
                                                    name="divisionID"
                                                    value={searchForm.divisionID}
                                                    onChange={(e) => handleDivisionChange(e.target)}>
                                                    <MenuItem value="0">--All Division--</MenuItem>
                                                    {generateDropDownMenu(divisions)}
                                                </Select>
                                                {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="searchDate">Date *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="searchDate"
                                                    name="searchDate"
                                                    type="date"
                                                    onChange={(e) => handleDateChange(e.target)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="fieldID">Field</InputLabel>
                                                <Select fullWidth
                                                    id="fieldID"
                                                    name="fieldID"
                                                    value={searchForm.fieldID}
                                                    onChange={(e) => handleFieldChange(e.target)}>
                                                    <MenuItem value="0">--All Field--</MenuItem>
                                                    {generateDropDownMenu(fields)}
                                                </Select>
                                                {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="fieldID">Session</InputLabel>
                                                <Select fullWidth
                                                    id="sessionID"
                                                    name="sessionID"
                                                    value={searchForm.sessionID}
                                                    onChange={(e) => handleChange(e)}>
                                                    <MenuItem value="0">--All Session--</MenuItem>
                                                    {generateDropDownMenu(sessions)}
                                                </Select>
                                                {errors["sessionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["sessionID"]}</FormHelperText>}
                                            </div>
                                        </div>

                                        <input
                                            type="submit"
                                            disabled={validate(schema, searchForm)}
                                            className="btn btn-primary"
                                            value="Generate"
                                        />
                                    </form>
                                </div>
                                <div className="w-100"></div>
                                <div className="col pl-5">
                                    {isTableHide ? null :
                                        <div>
                                            <div className="card">
                                                <div className="card-header"><h6>Weigh Details</h6></div>
                                                <div className="card-body">
                                                    {/* <p className="d-inline pr-3"><b>Net Amount : </b> {detailCard.gross} Kg</p> */}
                                                    <p className="d-inline pr-3"><b>Checkroll Amount : </b>{detailCard.net} Kg</p>
                                                    {/* <p className="d-inline pr-3"><b>Actual Amount : </b>{detailCard.total} Kg</p> */}
                                                    <div className="d-inline"><b>Total {detailCard.gainloss < 0 ? " Loss" : " Gain"} : </b><div className={detailCard.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}
                                                        style={{ fontSize: "14px" }}>{Math.abs(detailCard.gainloss)} Kg</div></div>
                                                    <br></br>
                                                </div>
                                            </div>
                                            <div>
                                                <table id="summaryReport"
                                                    style={{
                                                        display: "block", overflowX: "auto", whiteSpace: "nowrap",
                                                        maxWidth: "1400px", borderColor: "white"
                                                    }}>
                                                    <thead>
                                                        <tr>
                                                            <th>EPF No</th>
                                                            <th>Reg No</th>
                                                            <th>First Name</th>
                                                            <th>Division</th>
                                                            <th>Field</th>
                                                            {/* <th>Actual (Kg)</th>
                                                            <th>Net (Kg)</th> */}
                                                            <th>Checkroll (Kg)</th>
                                                            <th>Extra (Kg)</th>
                                                            <th>Total (Kg)</th>
                                                            {/* <th>G/L (Kg)</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tfoot>
                                                        <tr>
                                                            <th style={{ textAlign: "left" }} colSpan="4">Total</th>
                                                            <th style={{ textAlign: "left" }}>Employee Count {employeeCount}</th>
                                                            {/* <th style={{ textAlign: "right" }}>{detailCard.total}</th>
                                                            <th style={{ textAlign: "right" }}>{detailCard.gross}</th> */}
                                                            <th style={{ textAlign: "right" }}>{detailCard.net}</th>
                                                            <th style={{ textAlign: "right" }}>{detailCard.extraKg}</th>
                                                            <th style={{ textAlign: "right" }}>{detailCard.allTot}</th>
                                                            {/* <th style={{ textAlign: "center" }}>
                                                                <span className={detailCard.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}>
                                                                    {detailCard.gainloss < 0 ? "Loss " : "Gain "}
                                                                    {Math.abs(detailCard.gainloss)}
                                                                </span>
                                                            </th> */}
                                                        </tr>
                                                    </tfoot>
                                                    <tbody>
                                                        {finalData.map((row, index) => (
                                                            <>
                                                                <tr>
                                                                    <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.epfNo}</td>
                                                                    <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.registrationNumber}</td>
                                                                    <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.firstName}</td>
                                                                    <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.collectionPointName}</td>
                                                                    <td>{row.dataArray[0].fieldName}</td>
                                                                    {/* <td style={{ textAlign: "right" }}>{row.dataArray[0].actualAmount}</td>
                                                                    <td style={{ textAlign: "right" }}>{row.dataArray[0].grossAmount}</td> */}
                                                                    <td style={{ textAlign: "right" }}>{row.dataArray[0].netAmount}</td>
                                                                    <td style={{ textAlign: "right" }}>{row.dataArray[0].extraKg}</td>
                                                                    <td style={{ textAlign: "right" }} rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.total}</td>
                                                                    {/* <td style={{ textAlign: "right" }}>
                                                                        <span className={row.dataArray[0].gainLoss < 0 ? "badge badge-danger" : "badge badge-primary"}>
                                                                            {row.dataArray[0].gainLoss < 0 ? "Loss " : "Gain "}
                                                                            {Math.abs(row.dataArray[0].gainLoss)}
                                                                        </span>
                                                                    </td> */}
                                                                </tr>
                                                                {totalRowCreate(row.dataArray)}
                                                            </>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {!isReportButtonsEnabled ? null :
                                                <div className="pt-2">
                                                    <ReactToPrint
                                                        documentTitle={"Checkroll Weighment Sumamry Report"}
                                                        trigger={() => <input
                                                            type="button"
                                                            className="btn btn-primary pull-right ml-2"
                                                            value="Create PDF"
                                                        />}
                                                        content={() => componentRef.current}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePdf ref={componentRef} data={collectionCategoryReport} employeeCount={employeeCount}
                                                            lables={feildAvailabeDedauctionTypes} rowNames={contentRowNames} searchData={selectedSearchValues}
                                                            weighDetails={detailCard} detailDeductions={detailDeductions} finalData={finalData}/>
                                                    </div>
                                                    <input
                                                        type="button"
                                                        className="btn btn-primary pull-right ml-2"
                                                        value="Excel"
                                                        onClick={createFile}
                                                    />
                                                </div>}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

